import _checkPrecision from './internal/checkPrecision';
import unformat from './unformat';
import settings from './settings';

/**
 * Implementation of toFixed() that treats floats more like decimals
 *
 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
 * problems for accounting- and finance-related software.
 *
 * ```js
 *  (0.615).toFixed(2);           // "0.61" (native toFixed has rounding issues)
 *  accounting.toFixed(0.615, 2); // "0.62"
 * ```
 *
 * @method toFixed
 * @for accounting
 * @param {Float}   value         The float to be treated as a decimal number.
 * @param {Number} [precision=2] The number of decimal digits to keep.
 * @return {String} The given number transformed into a string with the given precission
 */
function toFixed (value, precision, roundValue) {
	//console.log("accounting.toFixed CUSTOM", value, precision, roundValue);
	if (roundValue === undefined) {
		roundValue = true;
	}
	precision = _checkPrecision(precision, settings.precision);
	if (roundValue === true) {
		const power = Math.pow(10, precision);
		//console.log("accounting.toFixed power", power, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round((value + 1e-8) * power) / power).toFixed(precision);
	} else {
		//console.log("accounting.toFixed CUSTOM", value);
		var exponentialForm = Number(unformat(value) + "e" + precision);
		//console.log("exponentialForm", exponentialForm);
		var rounded = Math.round(exponentialForm);
		//console.log("rounded", rounded);
		var finalResult = Number(rounded + "e-" + precision).toFixed(precision);
		//console.log("finalResult", finalResult);
		return finalResult;
	}
}

export default toFixed;
